import { Telephone } from 'models';

export class VerificationRequestCreate {
	title: string;
	firstName: string;
	lastName: string;
	email: string;
	redirectUrl: string;
	telephone: Telephone = new Telephone();
}

export class VerificationRequestStatus {
	id: number;
	identifier: string;
	url: string;

	firstName: string;
	lastName: string;
	fullName: string;
	email: string;

	phoneNumber: string;
	telephoneCode: string;
	telephoneNumber: string;

	verifierRejected: boolean;
	rejectionReason: string;

	deleted: boolean;
	expiryDate: Date;
	status: string;
	joinDate: Date;

	failureReason: string;

	isVerificationLinkActive: boolean;

	completedVerifications: Verification[];

	constructor(props: { [TKey in keyof VerificationRequestStatus]?: VerificationRequestStatus[TKey] }) {
		Object.assign(this, {
			...props,
		});
	}
}

export class Verification {
	name: VerificationType;
	provider: ProviderType;
	value: string;
	updatedDate: Date;
	verificationStatus: VerificationStatus;
	createdDate?: string;
	deletedDate?: string;
	id?: number;
	metaData?: any;
	superhogUserId?: string;
	screeningLink?: string;

	hasContract: boolean;
	isOverridableForVerification: boolean;

	constructor(props: { [key in keyof Verification]?: Verification[key] }) {
		Object.assign(this, {
			...props,
		});
	}
}
export class VerificationRequests {
	id: number;
	config: string;
	email: string;
	firstName: string;
	identifier: string;
	lastName: string;
	linkUsed: string;
	phoneNumber: string;
	summary: any;
	url: string;
	verifications: Verification[];
}

export enum VerificationTypes {
	'GovernmentId',
	'Contract',
	'Vaccine',
	'Screening',
	'PaymentValidation',
	'CriminalRecord',
	'CompanyDetail',
}

export type VerificationType = keyof typeof VerificationTypes;

export enum ProviderTypes {
	'Airbnb',
	'HooYu',
	'Jumio',
	'Superhog',
	'Covid',
}

export type ProviderType = keyof typeof ProviderTypes;

export enum VerificationStatuses {
	'Pending',
	'Confirmed',
	'Revoked',
	'Failed',
	'AwaitingCallback',
	'ForReview',
	'Not Started',
}

export type VerificationStatus = keyof typeof VerificationStatuses;

export class VerificationOverride {
	id: number;
	reason: string;
	newStatus: number;
	superhogUserId: string;
	verificationRequestId: number;

	constructor(props: { [key in keyof VerificationOverride]?: VerificationOverride[key] }) {
		Object.assign(this, {
			...props,
		});
	}
}

export class VerificationLiteCreate {
	firstName: string;
	lastName: string;
	email: string;
	telephone: Telephone = new Telephone();
}

export class VerificationLite {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	telephoneCode: string;
	telephoneNumber: string;
}
